// @flow
import React from 'react';
import Button from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';

type Props = {
    setIsOpen: (isOpen: boolean) => void,
    confirm: Function,
    loading: boolean,
    vc: Object,
};

export default function DeleteComponentModal({ setIsOpen, confirm, loading, vc, ...props }: Props) {
    return (
        <ModalTransition>
            <Modal {...props} shouldScrollInViewport onClose={() => setIsOpen(false)}>
                <ModalHeader>
                    <ModalTitle>Delete {vc.name}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>Deleting this component will remove it from all linked issues.</p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={loading}
                        iconAfter={loading ? <Spinner size="small" /> : null}
                        appearance="warning"
                        id="delete"
                        onClick={() => confirm(vc.id)}
                    >
                        Delete
                    </Button>
                    <Button isDisabled={loading} id="cancel" onClick={() => setIsOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </ModalTransition>
    );
}
